const ConfigurationSetting = () => {
    return(
        <div className="detail">
        <div className="title-text">
            <h3>Configuration</h3>
        </div>
        <div className='configuredetails'>
            <h5>General</h5>
            <div className='details'>
                <div className="divlist">
                    <p>Lorem Inspum</p>
                    <input type='text' />
                    <img src="/images/tickets/edit-ico.svg" className="editdivinfo" />
                </div>
                <div className="divlist"><p>New Ticket</p>
                    <input type='text' />
                    <img src="/images/tickets/edit-ico.svg" className="editdivinfo" />
                </div>
                <div className="divlist"><p>Lorem</p>
                    <input type='text' />
                    <img src="/images/tickets/edit-ico.svg" className="editdivinfo" />
                </div>
            </div>
        </div>
        <div className='configuredetails'>
            <h5>General</h5>
            <div className='details'>
                <div className="divlist">
                    <p>New Ticket</p>
                    <input type='text' />
                    <img src="/images/tickets/edit-ico.svg" className="editdivinfo" />
                </div>
                <div className="divlist"><p>New Ticket</p>
                    <input type='text' />
                    <img src="/images/tickets/edit-ico.svg" className="editdivinfo" />
                </div>
                <div className="divlist"><p>New Ticket</p>
                    <input type='text' />
                    <img src="/images/tickets/edit-ico.svg" className="editdivinfo" />
                </div>
            </div>
        </div>
        <div className='configuredetails'>
            <h5>General</h5>
            <div className='details'>
                <div className="divlist">
                    <p>New Ticket</p>
                    <input type='text' />
                    <img src="/images/tickets/edit-ico.svg" className="editdivinfo" />
                </div>
                <div className="divlist"><p>New Ticket</p>
                    <input type='text' />
                    <img src="/images/tickets/edit-ico.svg" className="editdivinfo" />
                </div>
                <div className="divlist"><p>New Ticket</p>
                    <input type='text' />
                    <img src="/images/tickets/edit-ico.svg" className="editdivinfo" />
                </div>
            </div>
        </div>
    </div>
    )
}
export default ConfigurationSetting;